import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNintendoswitchComponent } from './simple-icons-nintendoswitch.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNintendoswitchComponent ],
    exports:      [ SimpleIconsNintendoswitchComponent ],
    bootstrap:    []
})
export class SimpleIconsNintendoswitchModule {}
